import React from 'react';
import { useCommissionPlanDetails } from '../hooks/use-commission-plan-details.js';
import CommissionPlanDetailsPageView from './commission-plan-details-page-view.jsx';

function CommissionPlanDetailsPageContainer() {
  const state = useCommissionPlanDetails();
  return <CommissionPlanDetailsPageView {...state} />;
}

export default CommissionPlanDetailsPageContainer;
